import * as Yup from 'yup';

Yup.addMethod(Yup.mixed, 'validNumber', function(message) {
  return Yup.mixed().test('validNumber', message, function(value) {
    return /^\d+$/.test(value);
  });
});
